import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../auth';
import { Button } from '../ui/button';
import { MaintenancePage } from './MaintenancePage';
import { siteApi } from '../admin/siteApi';
import { BrowserMetadata } from '../BrowserMetadata';
import './maintenance.css';

const SiteContext = createContext(null);
export const useSiteAvailability = () => useContext(SiteContext);
export const SiteAvailability = ({ children }) => {
  const { user, loading } = useAuth();
  const [settings, setSettings] = useState(null), [error, setError] = useState('');
  const pending = useRef(false);
  const refresh = useCallback(async () => {
    if (pending.current) return;
    pending.current = true;
    try {
      const data = await siteApi('/site-settings', { cache: 'no-store' });
      setSettings((current) => !current || data.revision >= current.revision ? data : current);
      setError('');
    } catch { setError('Unable to check site availability.'); }
    finally { pending.current = false; }
  }, []);
  useEffect(() => {
    refresh(); const timer = setInterval(refresh, 5000);
    window.addEventListener('focus', refresh); window.addEventListener('gv-site-settings-updated', refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh); window.removeEventListener('gv-site-settings-updated', refresh); };
  }, [refresh]);
  const admin = user?.role === 'admin';
  const blocked = settings?.originals_lock === 'full' || (!admin && (settings?.originals_lock === 'user' || settings?.under_construction));
  const message = settings?.originals_lock === 'full' ? 'Originals are fully locked. New bets are paused for everyone.' : settings?.originals_lock === 'user' ? 'Originals are temporarily open to administrators only.' : settings?.under_construction ? 'The site is under construction. New bets are paused.' : '';
  return <SiteContext.Provider value={{ settings, blocked, message, error, refresh }}>
    <BrowserMetadata underConstruction={!!settings?.under_construction && !admin} />
    {loading || !settings ? <main className="maintenance-page" data-testid="site-availability-loading"><p role="status" data-testid="site-availability-status">{error || 'Loading GVRewards…'}</p>{error && <Button onClick={refresh} data-testid="site-availability-retry">Retry</Button>}</main> : settings.under_construction && !admin ? <MaintenancePage settings={settings} onExpire={refresh} /> : children}
  </SiteContext.Provider>;
};